<template>
  <div class="relative texture-bg-css clearfix">
    <div class="w">
      <div class="page-header"><Breadcrumb /></div>
      <BasicData></BasicData>
      <!-- <div class="collections"></div> -->
      <Collections></Collections>
      <!-- <div class="text-center img-title">
        <img
          src="../../../../static/images/basicData/ceramic-title.png"
          alt=""
        />
      </div>
      <div class="w-full t-content">
        <ceramicsContent type="collection"></ceramicsContent>
      </div> -->
    </div>
  </div>
  <!-- <router-view :key="$route.fullPath"></router-view> -->
</template>

<script>
import Breadcrumb from '@/components/common/Breadcrumb'
import BasicData from './basicData/Index'
import Collections from './collections/Index'

export default {
  name: 'me',
  components: {
    Breadcrumb,
    BasicData,
    Collections
  },
  data() {
    return {}
  },
  computed: {
    name() {
      return this.$route.name
    }
  },
  mounted: function() {
    // console.log('mounted')
  }
}
</script>
<style lang="scss" scoped>
.texture-bg-css {
  padding-bottom: 160px;
  min-height: 80vh;
}
</style>
